var React = require('react');

function NavCrossInline (props) {
    return React.createElement("svg",props,[React.createElement("line",{"x1":"13.5158","y1":"13.3536","x2":"0.646487","y2":"0.484211","stroke":"black","key":0}),React.createElement("line",{"x1":"14.2229","y1":"0.353553","x2":"1.35359","y2":"13.2229","stroke":"black","key":1})]);
}

NavCrossInline.defaultProps = {"width":"15","height":"14","viewBox":"0 0 15 14","fill":"none"};

module.exports = NavCrossInline;

NavCrossInline.default = NavCrossInline;
